import React, { useState } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const ButtonDiv = styled.div`
  display: flex;
  flex-direction: row;
  gap: calc(3vw + 3vmin);
  align-items: center;
  justify-content: center;
  margin-top: 7vh;
`;

const Button = styled.button`
  height: calc(50px + 3vmin);
  width: calc(110px + 3vmin);
  font-size: calc(1.3em + 2vmin);
  color: white;
  border: none;
  border-radius: 0.5em;
`;

const StartButton = styled(Button)`
  background-color: ${(props) =>
    props.type === 'start' ? '#4caf50' : '#282c34'};
  &:hover {
    background-color: ${(props) =>
      props.type === 'start' ? '#46a049' : '#282c34'};
  }
`;

const StopButton = styled(Button)`
  background-color: ${(props) =>
    props.type === 'stop' ? '#f44336' : '#282c34'};
  &:hover {
    background-color: ${(props) =>
      props.type === 'stop' ? '#da190b' : '#282c34'};
  }
`;

const RoomUnderCleaningButtons = (props) => {
  const { activeBtn } = useSelector((state) => state);
  const [disabledBtn, setDisabledBtn] = useState('');

  const disableClickedBtn = (btn) => {
    setDisabledBtn(btn);
  };

  return (
    <ButtonDiv>
      <StartButton
        type={activeBtn}
        onClick={() => {
          props.callRoomUnderCleaningApi('start');
          disableClickedBtn('start');
        }}
        disabled={activeBtn === 'stop' || disabledBtn === 'start'}
        style={{ cursor: activeBtn === 'start' ? 'pointer' : 'auto' }}
      >
        Start
      </StartButton>
      <StopButton
        type={activeBtn}
        onClick={() => {
          props.callRoomUnderCleaningApi('stop');
          disableClickedBtn('stop');
        }}
        disabled={activeBtn === 'start' || disabledBtn === 'stop'}
        style={{ cursor: activeBtn === 'stop' ? 'pointer' : 'auto' }}
      >
        Stop
      </StopButton>
    </ButtonDiv>
  );
};

export default RoomUnderCleaningButtons;
